module.exports = __webpack_public_path__ + "img/pic_coinstore_happyx4@3x.eb3c2298.png";